import Vue from "vue";
import VueRouter from "vue-router";
import Resource from "vue-resource";
import Meta from "vue-meta";
import App from "./App.vue";
import VModal from "vue-js-modal";
import VueAgile from "vue-agile";
import VueScrollTo from "vue-scrollto";
import Home from "./components/pages/AcoperisExpert.vue";
import Ruukki from "./components/pages/Ruukki.vue";
import Gerard from "./components/pages/Gerard.vue";
import Novatik from "./components/pages/Novatik.vue";
import Wetterbest from "./components/pages/Wetterbest.vue";
import Dakea from "./components/pages/Dakea.vue";
import Fakro from "./components/pages/Fakro.vue";
import Careers from "./components/pages/Careers.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faCheck,
	faMapMarker,
	faArrowLeft,
	faChevronUp,
	faChevronLeft,
	faPhone,
	faEnvelope,
	faUser,
	faInfo,
	faTimes,
	faFolder,
	faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
	faCheck,
	faMapMarker,
	faArrowLeft,
	faChevronUp,
	faChevronLeft,
	faPhone,
	faEnvelope,
	faUser,
	faInfo,
	faTimes,
	faFolder,
	faFilePdf
);

// import axios from 'axios'
// import VueAxios from 'vue-axios'

// Vue.prototype.$http = axios

// Making JQUERY global
const $ = require("jquery");
window.$ = $;

// IMPORT NORMALIZE.CSS
import "normalize.css";
// IMPORTING BOOTSTRAP JS PARTS
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/collapse'
// IMPORTING BOOTSTRAP SCSS PARTS
import "bootstrap/dist/css/bootstrap.css";
// IMPORTING GENERAL STYLES
import "./style.scss";

Vue.use(VueRouter);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VModal);
Vue.use(Resource);
Vue.use(VueAgile);
Vue.use(VueScrollTo);
Vue.use(Meta);
// Vue.use(VueAxios, axios)

const routes = [
	{ path: "/", component: Home },
	{ path: "/ruukki/:product", component: Ruukki },
	{
		path: "/ruukki/",
		redirect: "/ruukki/tigle-metalice-si-tabla-prefaltuita"
	},
	{ path: "/gerard/:product", component: Gerard },
	{ path: "/gerard", redirect: "/gerard/tigla-metalica-gerard-classic" },
	{ path: "/novatik/:product", component: Novatik },
	{ path: "/novatik", redirect: "/novatik/tigla-metalica-novatik-practik" },
	{ path: "/distributietransilvania", component: Wetterbest },
	{ path: "/dakea/:product", component: Dakea },
	{ path: "/dakea", redirect: "/dakea/ferestre-si-luminatoare-good" },
	{ path: "/fakro/:product", component: Fakro },
	{
		path: "/fakro",
		redirect: "/fakro/ferestre-de-mansarda-cu-dubla-articulare-preselect"
	},
	{ path: "/cariere/", component: Careers },
	{ path: "*", redirect: "/" }
];

const router = new VueRouter({
	routes,
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	}
});

new Vue({
	el: "#app",
	router,
	render: h => h(App),
	mounted() {
		// You'll need this for renderAfterDocumentEvent.
		document.dispatchEvent(new Event("render-event"));
	}
});



// WEBPACK FOOTER //
// ./src/main.js